// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1y1yR","label":"Radio_label__3Pk2W","checkMark":"Radio_checkMark__1eSRK","disabled":"Radio_disabled__1VHgw"};